const STORAGE_KEY = 'jusic_room_identity_v1';

// Only the server issues the credential; public connection/identity IDs cannot restore it.
export function loadRoomIdentity() {
    try {
        const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
        return value && typeof value.token === 'string' ? value : {};
    } catch (e) {
        return {};
    }
}

export function saveRoomIdentity(value) {
    if (!value || !value.token || !value.identityId) return;
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
            token: value.token,
            identityId: value.identityId
        }));
    } catch (e) { /* Music.vue keeps the credential in memory for this page's reconnects. */ }
}
